/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import { TreeNode } from "primereact/treenode";
import { useEffect, useState } from "react";
interface SelectedNodes {
  [key: string]: {
    checked: boolean;
    partialChecked: boolean;
    label: string;
  };
}
interface Node {
  key: string;
  label: string;
  children?: Node[];
}

type SelectedList = {
  [key: string]: {
    checked: boolean;
    partialChecked: boolean;
  };
};

const OrgHierarchyTooltip = (props: any) => {
  const [nodes, setNodes] = useState<TreeNode[]>([]);
  useEffect(() => {
    if (props.hierarchicalOrganizationwKey.length) {
      const selectedNodes: any = filterByText(
        props.hierarchicalOrganizationwKey,
        props.selectedKeyLsit[0]
      );
      setNodes(selectedNodes ?? []);
    }
  }, [props.selectedKeyLsit, props.hierarchicalOrganizationwKey]);

  function filterByText(objects: any, text: string) {
    function traverse(arr: any) {
      for (const item of arr) {
        if (item.label === text || (item.data && item.data === text)) {
          return [{ ...item, children: [] }];
        } else if (item.children) {
          const filteredChildren: any = traverse(item.children);
          if (filteredChildren.length > 0) {
            return [{ ...item, children: filteredChildren }];
          }
        }
      }
      return [];
    }

    const filteredObjects = traverse(objects);
    return filteredObjects.length > 0 ? filteredObjects : null;
  }

  const TreeNode = ({ node }: any) => {
    const style = { paddingLeft: "2px", listStyle: "none", margin: "0px" };
    const styles = { paddingLeft: "8px", listStyle: "none", margin: "0px" };

    return (
      <ul style={style}>
        <li>{node.label}</li>
        {node.children &&
          node.children.map((child: any, index: any) => (
            <div style={styles}>
              <TreeNode key={index} node={child} />
            </div>
          ))}
      </ul>
    );
  };

  const Tree = ({ filteredObj }: any) =>
    filteredObj?.map((item: any, index: any) => (
      <TreeNode key={index} node={item} />
    ));

  return (
    <>
      {nodes.length ? (
        <Tree filteredObj={nodes} />
      ) : (
        `You don't have access to ${props.selectedKeyLsit} Organisation `
      )}
    </>
  );
};

export default OrgHierarchyTooltip;
